class MC_TTPopup {
    constructor() {
        this.initPopup();
    }

    initPopup() {
        let buttonPopupInit = document.querySelectorAll('.trainer-dot');
        if (!buttonPopupInit.length) {
            return
        }
        let PopupWrappers = document.querySelectorAll('.tt-info-popup');
        if (!PopupWrappers.length) {
            return
        }

        for (let i = 0; i < buttonPopupInit.length; i++) {
            buttonPopupInit[i].addEventListener('click', function (e) {
                e.preventDefault();
                PopupWrappers.forEach(element => {
                    element.classList.remove('active');
                })
                let hrefElement = buttonPopupInit[i].getAttribute('data-id');
                document.querySelector(`.tt-info-popup[data-tainer-id=${hrefElement}]`).classList.add('active');
                document.querySelector(`.tt-info-popup[data-tainer-id=${hrefElement}]`).querySelector('.close').addEventListener('click', function (e) {
                    document.querySelector(`.tt-info-popup[data-tainer-id=${hrefElement}]`).classList.remove('active');
                })
            })
        }
    }
}
